import styled from "@emotion/styled";
import { surface, text, interactive, border as borderToken, zIndex, shadow, borderRadius, fontSize, controlFontSize, spacing, fontWeight, opacity, layout } from "@atlas-int/tokens";
import BaseCloseButton from "@atlas-int/ui/CloseButton";
import BaseButton from "@atlas-int/ui/Button";
import { TooltipAbove } from "@atlas-int/ui/Tooltip";

export const VizSettingsPanelContainer = styled.div`
  position: absolute;
  z-index: ${zIndex.panel};
  width: ${layout.navBarExpandedWidth};
  top: 130px;
  right: 3px;
  bottom: ${spacing[4]};
  display: flex;
  flex-direction: column;
  border-radius: ${borderRadius.lg};
  background-color: ${surface.raised};
  box-shadow: ${shadow.sm};
  height: 75vh;
`;

export const VizSettingsHeader = styled.div`
  background-color: ${interactive.default};
  display: flex;
  flex-direction: row;
  height: auto;
  border-radius: ${borderRadius.lg} ${borderRadius.lg} 0px 0px;
  font-size: ${controlFontSize.default};
`;

export const SettingsLabelContainer = styled.div`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  margin-left: ${spacing[10]};
  cursor: pointer;
  padding: ${spacing[4]} 0px;

  & img {
    width: ${spacing[10]};
    margin-right: ${spacing[2]};
  }
  color: ${text.onDark};
`;

export const VizSettingsBody = styled.div`
  border-top: 1px solid ${text.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px;
  margin-bottom: ${spacing[4]};
  background-color: ${surface.raised};
`;

export const VizSettingsOptionRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: ${spacing[4]} 0px;
  padding: 0px ${spacing[4]};
  align-items: center;
  box-sizing: border-box;
`;

export const VizSettingsOptionLabel = styled.div`
  font-size: ${fontSize.base};
`;

export const VizSettingsOptionSelector = styled.div`
  margin-left: auto;
  margin-right: ${spacing[4]};
  width: 50%;
`;

export const DisabledVizSettingsOptionSelector = styled(VizSettingsOptionSelector)`
  opacity: ${opacity.muted};
  cursor: not-allowed;
  width: 100%;
  & > * {
    pointer-events: none;
  }
`;

export const CloseButton = styled(BaseCloseButton)`
  margin-left: auto;
  color: ${text.onDark};
  font-size: ${fontSize["3xl"]};
  font-weight: ${fontWeight.light};
  padding: ${spacing[6]};
`;

export const NotAvailableTooltip = styled(TooltipAbove)`
  background-color: ${surface.raised};
  z-index: ${zIndex.dropdown};

  &::after {
    border-top-color: ${surface.raised};
  }
`;

export const DisabledVizSettingTooltipContainer = styled.div`
  margin-left: auto;
  margin-right: ${spacing[4]};
  width: 50%;
  position: relative;

  & > * {
    width: 100%;
  }
`;

export const DefaultSettingsButton = styled(BaseButton)`
  margin: ${spacing[4]} 0px;
`;
